import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: theme.palette.text.primary,
    fontFamily: "Poppins",
  },
  dropDown: {
    backgroundColor: theme.palette.secondary.light,
    "& ul.MuiList-padding": {
      paddingTop: "0px",
      paddingBottom: "0px",
    },
  },
  container: {
    width: "70%",
    flexWrap: "wrap",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "20px",
  },
  formControl: {
    alignItems: "center",
    justifyContent: "center",
    width: "250px",
    height: "40px",
    background: theme.palette.secondary.light,
    borderRadius: "10px",
  },

  dropdownDiv: {
    display: "flex",
    alignItems: "center",
    width: "250px",
    background: theme.palette.secondary.light,
  },

  selectText: {
    marginLeft: "10px",
    fontFamily: "Nunito Sans",
    opacity: "0.7",
  },

  iconStyle: {
    marginRight: "10px",
    height: "20px",
    color: theme.palette.secondary.main,
  },

  formLabelText: {
    height: "0%",
    width: "100%",
    opacity: "0",
    background: theme.palette.secondary.light,
    fontFamily: "Nunito Sans",
    fontStyle: "normal",
  },

  plusIcon: {
    width: "28px",
    height: "19px",
  },
  shotsPageNewShotButton: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    width: "auto",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "12px",
    color: theme.palette.text.secondary,
  },
  checkBoxText: {
    fontFamily: "poppins",
    color: theme.palette.text.primary,
  },
  backButton: {
    color: theme.palette.secondary.main,
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "5px",
    padding: "5px 10px",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px",
    },
    "&:hover": {
      color: theme.palette.secondary.main,
      backgroundColor: "transparent",
    },
  },
  disabledButton: {
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px",
    },
    color: theme.palette.text.tertiary,
    cursor: "not-allowed",
  },
  activeButton: {
    color: "white",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px",
    },
    "&:hover": {
      color: theme.palette.secondary.main,
      backgroundColor: "transparent",
    },
  },
}));

export default useStyles;
